import {
  Component,
  OnInit,
  ViewChild,
  Injector,
  Type,
  InjectionToken,
  AbstractType,
  ViewContainerRef,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
} from '@angular/core';
import { isFunction, get, isNil } from 'lodash';
import { IModalDialogOptions, EntityId } from '@app/shared/types';
import { lazyInject } from '@app/containers/base/decorators';
import { MODAL_COMPONENT_KEYS } from '@app/containers/component-keys';
import { CONTAINER_MAPPING } from '@app/containers/container-mapping';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-container-modal',
  templateUrl: './container-modal.component.html',
  styleUrls: ['./container-modal.component.scss'],
})
export class ContainerModalComponent implements OnInit, OnDestroy {
  @ViewChild('widgetContainer', { static: true, read: ViewContainerRef })
  public widgetContainer: ViewContainerRef;

  @lazyInject(ComponentFactoryResolver)
  public componentFactoryResolver: ComponentFactoryResolver;

  /**
   * will assigned by modal controller openModal method
   */
  public options: IModalDialogOptions = {};

  /**
   * need assign this when init this component
   */
  public modalId: EntityId;

  protected componentRef?: ComponentRef<any>;

  public constructor(protected injector: Injector) {}

  public inject<T>(
    token: Type<T> | InjectionToken<T> | AbstractType<T>,
    notFoundValue?: T,
  ): T {
    if (isFunction(this.injector.get)) {
      return this.injector?.get(token, notFoundValue);
    }

    return notFoundValue;
  }

  public ngOnInit(): void {
    this.modalId = get(this.options, 'modalId', null);

    this.instantiateWidget();
  }

  public ngOnDestroy(): void {
    if (isFunction(this.componentRef?.instance?.ngOnDestroy)) {
      this.componentRef.instance.ngOnDestroy();
    }
    this.componentRef = null;
    this.widgetContainer.clear();
  }

  public instantiateWidget(): void {
    if (this.componentRef) return; // already instantiated

    this.widgetContainer.clear();
    const componentConstructor = get(
      CONTAINER_MAPPING,
      this.options.contentComp,
    );
    const factory =
      this.componentFactoryResolver.resolveComponentFactory(
        componentConstructor,
      );
    this.componentRef = this.widgetContainer.createComponent(factory);

    if (
      !isNil(this.options.onContentComp) &&
      isFunction(this.options.onContentComp.created)
    ) {
      this.options.onContentComp.created(this.componentRef, {
        destroyFunc: this.ngOnDestroy.bind(this),
        reloadFunc: this.instantiateWidget.bind(this),
      });
    }
  }
}

export const MODAL_CONTAINER = {
  [MODAL_COMPONENT_KEYS.ContainerModal]: ContainerModalComponent,
};
